import { render, staticRenderFns } from "./CompanyDepartmentDetail.vue?vue&type=template&id=cdc798a0&scoped=true&"
import script from "./CompanyDepartmentDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyDepartmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDepartmentDetail.vue?vue&type=style&index=0&id=cdc798a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc798a0",
  null
  
)

export default component.exports